import type { BLOCK_TO_ADD } from '../../types/Blocks'
import type { FAQ_DATA, FAQ_ITEM_DATA, FAQ_ITEM_PARAMS, FAQ_PARAMS } from './types'

import { DEFAULT_PADDING, DEFAULT_WIDTH, generateForAllDevice } from '../const'

export const DEFAULT_FAQ_PARAMS = (): FAQ_PARAMS =>
  generateForAllDevice({ width: DEFAULT_WIDTH(), padding: DEFAULT_PADDING(), hidden: false })

export const DEFAULT_FAQ_DATA = (): FAQ_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'faq',
})

export const DEFAULT_FAQ_ITEM_PARAMS = (): FAQ_ITEM_PARAMS => ({
  open: false,
  disabled: false,
  ...generateForAllDevice({
    width: DEFAULT_WIDTH(),
    padding: DEFAULT_PADDING(),
    hidden: false,
  }),
})

export const DEFAULT_FAQ_ITEM_DATA = (): FAQ_ITEM_DATA => ({
  id: null,
  classes: null,
  styles: null,
  data: {
    header: 'Lorem Ipsum',
    value: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit',
  },
  type: 'faq-item',
})

export const FAQ_SEARCH = (): string[] => []
export const FAQ_PARSE = (): string[] => []

export const DEFAULT_FAQ_CHILDS = (): BLOCK_TO_ADD[] => [
  {
    type: 'block',
    params: DEFAULT_FAQ_ITEM_PARAMS(),
    data: DEFAULT_FAQ_ITEM_DATA(),
    interactions: {},
    properties: {
      searchable: FAQ_SEARCH(),
      parseable: FAQ_PARSE(),
    },
  },
  {
    type: 'block',
    params: DEFAULT_FAQ_ITEM_PARAMS(),
    data: DEFAULT_FAQ_ITEM_DATA(),
    interactions: {},
    properties: {
      searchable: FAQ_SEARCH(),
      parseable: FAQ_PARSE(),
    },
  },
  {
    type: 'block',
    params: DEFAULT_FAQ_ITEM_PARAMS(),
    data: DEFAULT_FAQ_ITEM_DATA(),
    interactions: {},
    properties: {
      searchable: FAQ_SEARCH(),
      parseable: FAQ_PARSE(),
    },
  },
]
